import React from 'react';
import logo from './navebar/logo.svg';

const Looder = () => {
    
    return (
        
        <div className={'flex flex-col'} style={{ width: '100%' ,height:'100vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
           <div className={'flex flex-col justify-center items-center text-center'}>
               <img src={logo} width={'60%'} className='img-loder' alt="" />
               <div className='container mt-5'>
                   Tatweer Company for Training, Qualification, Project Management, and Financial Technology (FinTech)
               </div>
           </div>
        </div>
    );
}

export default Looder;
